export enum DepositStepsEnum {
  COMPLETE_DEPOSIT = 1,
  SELECT_PAYMENT,
  FINISH
}
